import { parsePath } from 'history'

import type { Location, LocationInit } from './types'

export const locationToString = (location: LocationInit): string => {
  return (location.pathname || '') + (location.search || '') + (location.hash || '')
}

export const createLocation = (init: LocationInit): Location => {
  return {
    pathname: init.pathname,
    search: init.search ?? '',
    hash: init.hash ?? '',
    state: init.state ?? {},
    key: init.key ?? '',
  }
}

export const createLocationFromString = (init: string): Location => {
  const { pathname, search, hash } = parsePath(init)
  return {
    pathname: pathname ?? '/',
    search,
    hash,
    state: {},
    key: '',
  }
}
